<template>
    <a target="_BLANK" :href="feed.link">
        <SplitText
            :data="feed.title"
            class="feeded"
        />
    </a>
</template>
<script>
import SplitText from '@/components/SplitText'
export default {
    components: {
        SplitText
    },
    props: {
        feed: {
            type: Object,
            default() {}
        }
    }
}
</script>
<style lang="sass" scoped>
@import "@/styles/vars.sass"
a
    text-decoration: none
    &.v-leave-active
        transition: opacity .625s
        /deep/ .caption
            transition: .625s ease, opacity .3s .325s
    &.v-leave-to
        /deep/ .caption
            transform: translateY(-100%) !important
            opacity: 0
</style>
